import api_fabric from "../../api/ApiFabric";
/**
 *
 * @return {Shop}
 */

const api = function() {
  return api_fabric.getInstance("Shop", true);
};

const shop = {
  namespaced: true,
  state: {
    shop_list: null,
    opened_items: null,
    shop_view_type: "list", // list, favorite
    opened_box_is_repeatable: false,
  },
  mutations: {
    writeShopList(state, shop_list) {
      state.shop_list = shop_list;
    },
    writeOpenedItems(state, items_list) {
      state.opened_items = items_list;
    },
    removeOpenedItems(state) {
      state.opened_items = null;
    },
    writeShopViewType(state, new_view) {
      state.shop_view_type = new_view;
    },
    writeFavorite(state, payload) {
      state.shop_list.filter(box => box.id === payload.id)[0].favorite = payload.new_favorite;
    },
    writeIsBoxRepeteable(state, type) {
      state.opened_box_is_repeatable = type;
    },
  },
  getters: {
    getShopList(state) {
      return state.shop_list;
    },
    getOpenedItems(state) {
      return state.opened_items;
    },
    getShopView(state) {
      return state.shop_view_type;
    },
    isFavoriteEmpty(state) {
      return !state.shop_list.some(box => box.favorite);
    },
    getBoxContent: state => id => {
      return state.shop_list.filter(box => box.id === id)[0];
    },
    isBoxRepeteable(state) {
      return state.opened_box_is_repeatable;
    },
  },
  actions: {
    getShopList({ commit }) {
      return new Promise(resolve => {
        api()
          .getShopList()
          .then(response => {
            if (response.success) {
              commit("writeShopList", response.success.data.data);
              resolve();
            }
          });
      });
    },
    openShopItem({ commit }, data) {
      return new Promise(resolve => {
        api()
          .openShopItem(data)
          .then(response => {
            if (response.success) {
              commit("writeOpenedItems", response.success.data.data);
              resolve();
            }
          });
      });
    },
    addToFavorite({ commit }, data) {
      return new Promise(resolve => {
        api()
          .addToFavorite({ id: data })
          .then(response => {
            if (response.success) {
              commit("writeFavorite", { id: data, new_favorite: true });
              resolve();
            }
          });
      });
    },
    removeFromFavorite({ commit }, data) {
      return new Promise(resolve => {
        api()
          .removeFromFavorite({ id: data })
          .then(response => {
            if (response.success) {
              commit("writeFavorite", { id: data, new_favorite: false });
              resolve();
            }
          });
      });
    },
  },
};

export default shop;
